import React, { useState, useEffect } from 'react';
import GameButton from '../../../components/GameButton';
import { AI_COLORS, AI_FONTS, Confetti } from '../shared';

const questoes = [
  {
    afirmacao: 'Perder dentes faz parte do envelhecimento.',
    verdade: false,
    explicacao: 'Com cuidados adequados, é possível manter os dentes ao longo de toda a vida.',
  },
  {
    afirmacao: 'Boca seca pode aumentar o risco de problemas bucais.',
    verdade: true,
    explicacao: 'A saliva ajuda a proteger os dentes e a boca. A falta de saliva aumenta o risco de cáries e infecções.',
  },
  {
    afirmacao: 'Estresse pode influenciar a saúde bucal.',
    verdade: true,
    explicacao: 'Em algumas pessoas, o estresse pode estar relacionado ao apertamento dos dentes (bruxismo) e agravar doenças gengivais.',
  },
  {
    afirmacao: 'Feridas na boca que não cicatrizam merecem atenção.',
    verdade: true,
    explicacao: 'Qualquer alteração na boca que dure mais de 15 dias deve ser avaliada por um cirurgião dentista pode ser sinal de câncer bucal.',
  },
  {
    afirmacao: 'Usar fio dental apenas quando há alimento preso entre os dentes é suficiente.',
    verdade: false,
    explicacao: 'O fio dental deve fazer parte da rotina diária para remover placa bacteriana e prevenir cáries e gengivite.',
  },
  {
    afirmacao: 'Escovar os dentes com muita força limpa melhor.',
    verdade: false,
    explicacao: 'Escovar com muita força pode desgastar dentes e machucar a gengiva, causando a Lesão Cervical Não Cariosa (LCNC).',
  },
  {
    afirmacao: 'Fumar pode aumentar o risco de doenças da boca.',
    verdade: true,
    explicacao: 'O tabagismo está relacionado a diversos problemas bucais, incluindo doença periodontal e câncer de boca.',
  },
  {
    afirmacao: 'Mau hálito sempre acontece por causa do estômago.',
    verdade: false,
    explicacao: 'Muitas vezes o mau hálito está relacionado à própria boca e à higiene inadequada.',
  },
  {
    afirmacao: 'Beber água pode ajudar em casos de sensação de boca seca.',
    verdade: true,
    explicacao: 'A hidratação ajuda a melhorar o conforto e a saúde da boca em casos de xerostomia.',
  },
  {
    afirmacao: 'Cárie pode acontecer em adultos e idosos.',
    verdade: true,
    explicacao: 'A cárie pode surgir em qualquer fase da vida. Idosos são especialmente vulneráveis à cárie radicular.',
  },
  {
    afirmacao: 'Posso usar palito de madeira ao invés do fio dental para limpar os dentes.',
    verdade: false,
    explicacao: 'O palito de madeira não limpa os dentes adequadamente e ainda pode machucar a gengiva.',
  },
];

function embaralhar(arr) {
  return [...arr].sort(() => Math.random() - 0.5);
}

export default function MitosVerdades() {
  const [perguntas, setPerguntas] = useState([]);
  const [atual, setAtual] = useState(0);
  const [pontos, setPontos] = useState(0);
  const [feedback, setFeedback] = useState(null);
  const [fim, setFim] = useState(false);

  useEffect(() => {
    setPerguntas(embaralhar(questoes));
  }, []);

  const responder = (valor) => {
    if (feedback !== null) return;
    const q = perguntas[atual];
    const acertou = valor === q.verdade;
    if (acertou) setPontos((p) => p + 1);
    setFeedback({ acertou, explicacao: q.explicacao });

    setTimeout(() => {
      setFeedback(null);
      if (atual + 1 < perguntas.length) {
        setAtual((a) => a + 1);
      } else {
        setFim(true);
      }
    }, 4500);
  };

  const reiniciar = () => {
    setPerguntas(embaralhar(questoes));
    setAtual(0);
    setPontos(0);
    setFeedback(null);
    setFim(false);
  };

  if (!perguntas.length)
    return <p style={{ paddingTop: 100, textAlign: 'center' }}>Carregando...</p>;

  if (fim) {
    const pct = Math.round((pontos / perguntas.length) * 100);
    return (
      <div style={styles.wrap}>
        <div style={styles.card}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '3rem', marginBottom: 8 }}>
              {pct >= 80 ? '🏆' : pct >= 60 ? '👍' : '📚'}
            </div>
            <h2 style={{ fontFamily: AI_FONTS.title, color: AI_COLORS.blue900, fontSize: '1.8rem', margin: '0 0 8px' }}>
              Fim do jogo!
            </h2>
            <div style={{ fontSize: '3rem', fontWeight: 'bold', color: AI_COLORS.blue400, margin: '16px 0' }}>
              {pontos}/{perguntas.length}
            </div>
            <p style={{ lineHeight: 1.7, marginBottom: 28, color: AI_COLORS.textDark }}>
              {pct >= 80
                ? 'Parabéns! Você tem ótimo conhecimento sobre saúde bucal!'
                : pct >= 60
                ? 'Bom resultado! Revise os conteúdos e tente novamente!'
                : 'Explore as páginas do site para aprender mais e tente de novo!'}
            </p>
            <GameButton text="Jogar novamente" variant="info" onClick={reiniciar} />
          </div>
        </div>
      </div>
    );
  }

  const q = perguntas[atual];
  return (
    <div style={styles.wrap}>
      {feedback?.acertou && <Confetti key={atual} duration={4000} />}
      <div style={{ maxWidth: 620, width: '100%' }}>
        <h2 style={{ fontFamily: AI_FONTS.title, color: AI_COLORS.blue900, textAlign: 'center', marginBottom: 4 }}>
          Mitos e Verdades
        </h2>
        <p style={{ color: AI_COLORS.textMuted, textAlign: 'center', marginBottom: 20 }}>
          Afirmação {atual + 1} de {perguntas.length}
        </p>

        <div style={styles.progress}>
          <div style={{ ...styles.progressBar, width: `${(atual / perguntas.length) * 100}%` }} />
        </div>

        <div style={{ ...styles.card, marginTop: 16 }}>
          <p style={styles.afirmacao}>{q.afirmacao}</p>

          {feedback ? (
            <div style={{
              background: feedback.acertou ? AI_COLORS.green50 : '#FCE4EC',
              borderLeft: `4px solid ${feedback.acertou ? '#4CAF50' : '#EF9A9A'}`,
              borderRadius: 10,
              padding: '14px 18px',
              lineHeight: 1.7,
            }}>
              <strong style={{ fontSize: '1.05rem' }}>
                {feedback.acertou ? '✅ Correto!' : '❌ Incorreto!'}
              </strong>
              <p style={{ margin: '8px 0 0' }}>{feedback.explicacao}</p>
            </div>
          ) : (
            <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
              <GameButton text="✅ Verdade" variant="success" onClick={() => responder(true)} />
              <GameButton text="❌ Mito" variant="danger" onClick={() => responder(false)} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #E3F2FD 0%, #EDE7F6 55%, #B3E5FC 100%)',
    padding: '80px 24px 120px',
    fontFamily: AI_FONTS.body,
  },
  card: {
    background: 'white',
    borderRadius: 16,
    padding: '28px 26px',
    maxWidth: 620,
    width: '100%',
    boxShadow: '0 6px 24px rgba(1,87,155,0.12)',
    textAlign: 'center',
  },
  afirmacao: {
    fontSize: '1.12rem',
    fontWeight: 700,
    color: AI_COLORS.textDark,
    lineHeight: 1.6,
    marginBottom: 28,
    fontFamily: AI_FONTS.body,
  },
  progress: {
    width: '100%',
    height: 8,
    background: '#e0e0e0',
    borderRadius: 4,
    overflow: 'hidden',
  },
  progressBar: {
    height: '100%',
    background: AI_COLORS.blue400,
    transition: 'width 0.4s ease',
  },
};
